module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/.6.26.0@babel-runtime/regenerator/index.js
// module id = 240
// module chunks = 1